import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from 'src/app/core/model/user-model';
import { baseUrl } from 'src/app/global-variables';
import { WebengageService } from '../analytics-repository/webengage.service';
import { CheckMetrixService } from '../checkMetrix/checkMetrix.service';
import { UserDataService } from '../user-repository/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class StartupService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService,
    private webengage: WebengageService,
    private CheckMetrixService: CheckMetrixService
  ) {}
  sayHiToServer(user: User) {
    const headerDict = this.userDataService.getHeaderDict();

    this.http
      .post(
        baseUrl + 'api/v2/logs',
        {
          user: user._id,
          identifier: 'appOpen',
          timestamp: new Date().toISOString(),
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        console.log(result);
      });
  }
  started() {
    console.log('app launched');
    let user: User = JSON.parse(localStorage.getItem('user'));
    if (user && user._id) {
      this.sayHiToServer(user);
      this.webengage.appLaunch();
      this.webengage.userLoggedin(user);
      this.CheckMetrixService.checkMetrix();
    }
  }
}
